import { RawDraftContentState } from "draft-js";
import { FaqData } from "entities/faqs/types";
import { Dispatch, SetStateAction } from "react";
import { InputHookResult } from "shared/hooks/useInputState";
import { Translations } from "shared/types/languages";

export type FaqDetailsType = {
  isLoading: boolean;
  isSubmitting: boolean;
  selectedTab: FaqDetailsTabs;
  setSelectedTab: Dispatch<SetStateAction<FaqDetailsTabs>>;
  translations?: Translations;
  setTranslations: Dispatch<SetStateAction<Translations | undefined>>;
  faqData: FaqData | null;
  handleDrawerClose: () => void;
  questionInput?: InputHookResult;
  answerInput?: InputHookResult;
  disabled: boolean;
  handleSaveDraft: () => void;
  handleSaveActive: () => void;
  handleSaveTranslations: () => void;
  editorContent: RawDraftContentState | null;
  handleEditorChange: (content: RawDraftContentState) => void;
  handleTranslationEditorChange: (
    locale: string,
    content: RawDraftContentState,
  ) => void;
};

export enum FaqDetailsTabs {
  General,
  Translations,
}

export enum ManagedTranslations {
  Question = "Question",
  Answer = "Answer",
}
